export const SEE_BREAKDOWN_SLIDE_TEXT = "See breakdown slide";
